import { CountRpc } from "@dots-projects/types";
import { useEffect, useState } from "react";
import { BotExecutionsRpc } from "../../lib/discordTypes";
import { getSupaClient, getWorkspace } from "../../lib/supabase";

/**
 * Hook that returns the data for the automations widget
 *
 * @returns
 *  loading - loading status true or false
 *  executionsCount - total number of executions in this community
 *  automationsCount - total number of live triggers
 *  executions - executions in the indicated time period
 *  error - if there is any error while pulling the data, it is stored in this variable
 */

export function useAutomations(startTime: any, endTime: any) {
  const guildId = localStorage.getItem("guild-id") || "";
  const supabase = getSupaClient();
  const workspace = getWorkspace(supabase);
  const [loading, setLoading] = useState(true);
  const [executionsCount, setExecutionsCount] = useState(0);
  const [automationsCount, setAutomationsCount] = useState(0);
  const [executions, setExecutions] = useState<BotExecutionsRpc[] | null>(null);
  const [error, setError] = useState<any>(null);

  useEffect(() => {
    loader();
  }, [startTime, endTime]);

  const loader = async () => {
    setLoading(true);
    await loadExecutionsCount();
    await loadExecutions();
    await loadAutomations();
    setLoading(false);
  };

  const loadAutomations = async () => {
    const { data, error } = await supabase
      .from("triggers")
      .select("*")
      .eq("community_id", guildId)
      .eq("is_draft", false)
      .eq("is_active", true);

    if (error) {
      console.error(error);
      setError(error);
    }
    if (data) {
      setAutomationsCount(data.length);
    }
  };

  const loadExecutionsCount = async () => {
    const { error, data } = await supabase.rpc<CountRpc>(
      "discord_bot_executions_count",
      {
        guild_id: guildId,
        start_time: startTime,
        end_time: endTime,
      }
    );
    if (error) {
      console.error(error);
      setError(error);
    }
    if (data && data.length) {
      setExecutionsCount(data[0].total_count);
    }
  };

  const loadExecutions = async () => {
    const nExecutions = 4;
    const { error, data } = await supabase.rpc<BotExecutionsRpc>(
      "discord_bot_last_n_executions",
      {
        guild_id: guildId,
        start_time: startTime,
        end_time: endTime,
        number_of_executions: nExecutions,
      }
    );
    if (error) {
      console.error(error);
      setError(error);
    }
    if (data && data.length) {
      setExecutions(data);
    }
  };

  return {
    loading,
    executionsCount,
    automationsCount,
    executions,
    error,
  };
}
